import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enTranslation from '../locales/en/translation.json'
import nlTranslation from '../locales/nl/translation.json'
import enClock from '../locales/en/timeClock.json'
import nlClock from '../locales/nl/timeClock.json'

const resources = {
  en: {
    translation: { ...enTranslation, timeClock: enClock },
  },
  nl: {
    translation: { ...nlTranslation, timeClock: nlClock },
  },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en', // fallback language if translation not found
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    debug: false, // set to true for development debugging
  })

export default i18n
